import { localSetStorage, loginStorageProps } from '@/lib/storage';

export const keepEmail = (email: string, keep: boolean = false, auth: string = 'email', sns: string = '') => {
  const payload: loginStorageProps = {
    key: 'login',
    value: {
      email,
      keep: keep,
      auth,
      sns,
    },
  };
  localSetStorage(payload);
};
